import moment from 'moment-timezone'

export const TIME_ZONE = 'America/Los_Angeles'
export const END_DATE = '2025-01-04 00:00:00'

export const PROMO_END_DATE = moment.tz(END_DATE, TIME_ZONE).toDate()
